import { Component, inject } from '@angular/core'
import { Router } from '@angular/router'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatDialog } from '@angular/material/dialog'
import { computed } from '@angular/core'

import { OperatorDataState } from '@states/operator-data'
import { removeLocalStorage, STORAGE_KEYS } from '@utils/storage'
import { ChatOverlay } from '@components/chat-overlay'

@Component({
    selector: 'app-header',
    template: `
		<div class="user-data">
			<span>Welcome</span>
			<strong>{{ locationName() }}</strong>
		</div>
		<button type="button" class="color-btn" mat-icon-button (click)="onOpenChat()">
			<mat-icon>chat</mat-icon>
		</button>
		<button type="button" class="color-btn" mat-icon-button (click)="onEndSession()">
			<mat-icon>logout</mat-icon>
		</button>
	`,
    styleUrl: './header.component.scss',
    imports: [MatButtonModule, MatIconModule]
})
export class AppHeaderComponent {
	readonly #router = inject(Router)
	readonly #dialog = inject(MatDialog)
	readonly #operatorDataState = inject(OperatorDataState)

	readonly locationName = computed(() => this.#operatorDataState.metadata()?.locationName ?? '')

	onOpenChat(): void {
		this.#dialog.open(ChatOverlay, {
			width: '100dvw',
			maxWidth: '100dvw',
			height: '100dvh',
			panelClass: 'chat-fullscreen',
		})
	}

	onEndSession(): void {
		removeLocalStorage(STORAGE_KEYS.AUTH)

		this.#operatorDataState.operatorData.set(null)
		this.#router.navigate(['/auth/sign-in'])
	}
}
